import { SVGProps } from "react";

export function SendEmail(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="25px"
      height="25px"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <path d="M44 24V9H24H4V24V39H24"></path>
        <path d="M44 34L30 34"></path>
        <path d="M39 29L44 34L39 39"></path>
        <path d="M4 9L24 24L44 9"></path>
      </g>
    </svg>
  );
}
